import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  const load = useCallback(async () => {
    try {
      const r = await api.get("/branding");
      setBranding(r.data);
    } catch (_e) {
      setBranding({ system_name: "Apotheken Portal", primary_color: "#1D4ED8" });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    if (branding?.system_name) document.title = branding.system_name;
    if (branding?.favicon_b64) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = branding.favicon_b64;
    }
  }, [branding]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding, theme, setTheme, reload: load }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
